/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components'

export const ProductsStyles = styled.div<any>`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
  gap: 10px 20px;
  margin-bottom: var(--spacing-margin-large);
  grid-auto-flow: dense;

  .slot-wrapper {
    position: relative;
    z-index: 9;
  }
  .content-line-accountable-units {
    display: ${(props) => (props.simpleView ? 'none' : '')};
  }
  .product__content__name {
    p {
      color: var(--color-black);
    }
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
  @media screen and (max-width: 576px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const AdsBannerContainer = styled.div<any>`
  border-radius: 4px;
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(
    ${({ elementNumber }) => elementNumber || 1},
    1fr
  );
  gap: 10px 20px;
  justify-content: center;
  align-items: center;
  &:first-child {
    margin: 10px 0;
  }
`
